export default __webpack_public_path__ + "static/media/2475.9699a941.png";